export default __webpack_public_path__ + "static/media/TheGlobalBlueJeansTransformation.085aaf17.jpg";